$(document).ready(function () {

    _utilityHub.client.pulisciSessione = function () {
        sessionStorage.clear();
    };

    //----------------------- Notifiche -----------------------

    _notifiche.client.notifica = function (value: Notifica) {
        switch (value.Tipo) {
            case TipoNotifica.Success:
                toastr.success(value.Messaggio, value.Titolo, _optionsNotifiche);
                break;
            case TipoNotifica.Info:
                toastr.info(value.Messaggio, value.Titolo, _optionsNotifiche);
                break;
            case TipoNotifica.Warning:
                toastr.warning(value.Messaggio, value.Titolo, _optionsNotifiche);
                break;
            case TipoNotifica.Error:
                toastr.error(value.Messaggio, value.Titolo, _optionsNotifiche);
                break;
        }
    };

    _notifiche.client.updateTotaleOrdiniAsync = function (totale: number) {
        const button = document.getElementById('btn-totale-ordini-aperti');
        const value = document.getElementById('n-totale-ordini-aperti');
        if (button) {
            if (totale <= 0) {
                button.style.display = 'none';
            }
            else if (value) {
                value.innerHTML = totale.toString();
            }
        }
    };

    _notifiche.client.updateContatoreAsync = function (idContatore:string , valore: number) {
        const contatore = document.getElementById(idContatore);
        if (contatore) {
            contatore.innerHTML = valore.toString();
        } else {
            console.warn(contatore);
            console.warn("Contatore con id: " + idContatore + ", non trovato")
        }
    }

    let _optionsNotifiche: ToastrOptions = {
        closeButton: true,
        debug: false,
        newestOnTop: true,
        progressBar: true,
        positionClass: "toast-bottom-right",
        preventDuplicates: false,
        onclick: null,
        showDuration: 400,
        hideDuration: 1000,
        timeOut: 2000,
        extendedTimeOut: 1000,
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut"
    };
});

//-----------------------------------------------------------------------------------

interface SignalR {
    notificheHub: NotificheHub;
};

interface NotificheHub {
    server: NotificheHubServer;
    client: NotificheHubClient;
};

interface NotificheHubServer {
    //inviaNotifica(obj: Notifica): JQueryPromise<void>;
};

interface NotificheHubClient {
    init: () => void;
    notifica: (value: Notifica) => void;
    updateTotaleOrdiniAsync: (totale: number) => void;
    updateContatoreAsync: (idContatore: string, valore: number) => void;
};

class Notifica {
    Tipo: TipoNotifica;
    Titolo: string;
    Messaggio: string;
}

enum TipoNotifica {
    Success,
    Info,
    Warning,
    Error
}